<template>
  <div class="grid gap-4 m-4 sm:grid-cols-3 lg:grid-cols-6">
    <statistics-card-line
        v-for="card in cards"
        hideChart
        icon-right
        class="mb-base m-2"
        :icon="card.icon"
        :statistic="getValueByKey(card.key)"
        :text-color="card.color"
        :color="card.color"
        :statisticTitle="card.title"></statistics-card-line>
  </div>
</template>

<script>
export default {
  name: "CsdSummaryCard",
  props: {
    invoiceRequired: {
      required: true,
      type: Number
    },
    csdLoaded: {
      required: true,
      type: Number
    },
    csdWithoutLoad: {
      required: true,
      type: Number
    },
    csdPending: {
      required: true,
      type: Number
    },
    csdValid: {
      required: true,
      type: Number
    },
    csdWithError: {
      required: true,
      type: Number
    },
  },
  data: () => ({
    cards: [
      {
        title: 'Requieren factura',
        icon: 'UserIcon',
        color: 'success',
        key: 'invoiceRequired'
      },
      {
        title: 'CSD Cargados',
        icon: 'FileIcon',
        color: 'success',
        key: 'csdLoaded'
      },
      {
        title: 'CSD sin cargar',
        icon: 'FileIcon',
        color: 'danger',
        key: 'csdWithoutLoad'
      },
      {
        title: 'CSD pendientes de validación',
        icon: 'FileIcon',
        color: 'warning',
        key: 'csdPending'
      },
      {
        title: 'CSD validados',
        icon: 'FileIcon',
        color: 'success',
        key: 'csdValid'
      },
      {
        title: 'CSD con error',
        icon: 'FileIcon',
        color: 'danger',
        key: 'csdWithError'
      }
    ]
  }),
  methods: {
    getValueByKey(key) {
      if(!this[key])
        return 0;
      return this[key]
    }
  }
}
</script>

<style scoped>

</style>
